export enum RecommendationType {
    LANDING_PAGE = "landing_page",
    RECENTLY_VIEWED = "recently_viewed",
    FOR_YOU = "for_you",

    // Accepts product_id(s)
    RELATED = "related",
    CROSS_SELL = "cross_sell",
    AFTER_BASKET = "after_basket",
    CHECKOUT = "checkout",
    SEARCH = "search"
}
